import Vue from 'vue'
import { formatMoney } from '@/lib/util'
import state from '@/lib/appState'

Vue.component('product-subscription', {
  props: [
    'activeVariant',
    'defaultPurchaseType',
    'quantity',
    'formattedPrice',
    'totalPrice',
    'defaultDeliveryFrequency',
    'isFormBar'
  ],
  data () {
    const product = window.BARREL.product
    return {
      state,
      product,
      planId: -1,
      purchaseType: this.defaultPurchaseType,
      showPopup: false
    }
  },
  watch: {
    'purchaseType' (value) {
      if (value === 'onetime') this.updateProp('planId', -1)
    },
  },
  mounted () {
    this.handlePurchaseType(this.defaultPurchaseType)
    document.addEventListener('click', this.handleClickOutside)
  },
  unmounted () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  computed: {
    onetimeVariantPrice () {
      return formatMoney(parseFloat(this.activeVariant.price))
    },
    onetimeVariantCompareAtPrice () {
      return formatMoney(parseFloat(this.activeVariant.compare_at_price))
    },
    onetimeVariantHasDiscount () {
      return parseFloat(this.activeVariant.compare_at_price) > parseFloat(this.activeVariant.price)
    },
    subscriptionSavePrice () {
      if (this.subscriptionDiscountType === 'percentage') {
        return formatMoney(parseFloat((100 - this.subscriptionDiscount) * this.activeVariant.price / 100))
      } else {
        return formatMoney(parseFloat(this.activeVariant.price - this.subscriptionDiscount))
      }
    },
    subscriptionHasDiscount () {
      return parseFloat(this.subscriptionDiscount) > 0
    },
    subscriptionDetails () {
      const discountType = this.subscriptionDiscountType === 'percentage' ? '%' : ''
      return `(${!this.subscriptionHasDiscount ? '' : this.subscriptionDiscount + discountType})`
    },
    getPackVariant () {
      return parseFloat(this.activeVariant.title)
    },
    subscriptionDiscountType () {
      return this.sellingPlan ? this.sellingPlan[0].price_adjustments[0].value_type : 'percentage'
    },
    subscriptionDiscount () {
      return this.sellingPlan ? this.sellingPlan[0].price_adjustments[0].value : 0
    },
    sellingPlan () {
      return this.product.selling_plan_groups && this.product.selling_plan_groups.length ? this.product.selling_plan_groups[0].selling_plans : null
    },
    intervalFrequency () {
      return this.product.selling_plan_groups && this.product.selling_plan_groups.length ? this.product.selling_plan_groups[0].options[0].values : null
    },
    intervalFrequencyOptions () {
      const intervalFrequency = this.intervalFrequency.map(item => ({
        label: this.isFormBar ? this.sellingPlan.find(plan => plan.options[0].value === item).name : item,
        value: this.sellingPlan.find(plan => plan.options[0].value === item).id
      }))
      return intervalFrequency
    }
  },
  methods: {
    updateProp (prop, value) {
      this.$emit('change', prop, value)
    },
    getOptionValue () {
      return this.intervalFrequencyOptions[0].value
    },
    handlePurchaseType (value) {
      this.purchaseType = value
      this.updateProp('purchaseType', value)
      if (value === 'onetime') {
        this.updateValue(-1)
        this.updateProp('planId', -1)
      } else {
        this.updateValue(this.intervalFrequencyOptions[0].value)
        this.updateProp('planId', this.intervalFrequencyOptions[0].value)
      }
    },
    handleIntervalFrequencyChange ({ value }) {
      this.planId = value
      this.updateProp('planId', value)
      this.updateValue(value)
    },
    updateValue(value) {
      const selectEls = document.querySelectorAll('.product-form__interval-frequency select')
      selectEls.forEach(select => select.value = value)
    },
    togglePopup() {
      this.showPopup = !this.showPopup
    },
    handleClickOutside(event) {
      if (this.showPopup && !this.$refs.popup.contains(event.target) && !this.$refs.subscriptionBox.contains(event.target)) {
        this.showPopup = false
      }
    },
  }
})
